module.exports = __webpack_public_path__ + "static/media/IMAGEN-DIGITAL-THERAP.3f5255b9.png";